import type { Option, SharedSelectProps } from "./internal/types";
import useTranslation from "@hooks/use_translation";
import { useSharedReactSelectProps } from "./internal/hooks/use_shared_react_select_props";
import { SelectWrapper } from "./internal/select_wrapper";
import { useReactSelect } from "./internal/hooks/use_react_select";

interface MultiSelectProps extends SharedSelectProps {
  onChange: (values: Option[]) => void;
  values: Option[];
}

export const MultiSelect = ({
  clearable = false,
  creatable = false,
  disabled = false,
  error,
  helperText,
  label,
  onChange,
  options,
  placeholder,
  required = false,
  values,
  ...dataProps
}: MultiSelectProps) => {
  const { t } = useTranslation("sprout");
  const { id, ...sharedReactSelectProps } = useSharedReactSelectProps(
    (newValue) => onChange(newValue as Option[]),
    { error, label },
  );
  const ReactSelect = useReactSelect({ creatable });

  return (
    <SelectWrapper
      selectId={id}
      label={label}
      error={error}
      helperText={helperText}
      disabled={disabled}
      {...dataProps}
      required={required}
    >
      <ReactSelect
        id={id}
        {...sharedReactSelectProps}
        isClearable={clearable}
        isDisabled={disabled}
        isMulti
        options={options}
        placeholder={placeholder || t("select.placeholder")}
        value={values}
      />
    </SelectWrapper>
  );
};
